// API đăng nhập + hồ sơ. Backend THM (api/) — token qua header x-access-token, response bọc { statusCode, data }.
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.tuehaiminh.vn/api';

const TIMEOUT_MS = 15000;
const RETRY_DELAYS_MS = [500, 1500];
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// GET lỗi 5xx / mạng → thử lại 2 lần; POST/PUT không thử lại (tránh tạo 2 bản ghi).
export const fetchWithTimeout = async (url, options = {}) => {
  const { timeout, noRetry, ...fetchOpts } = options;
  const method = (fetchOpts.method || 'GET').toUpperCase();
  const maxAttempts = noRetry || method !== 'GET' ? 1 : RETRY_DELAYS_MS.length + 1;
  let lastError;
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout || TIMEOUT_MS);
    try {
      const res = await fetch(url, { ...fetchOpts, signal: controller.signal });
      clearTimeout(id);
      if (res.status >= 500 && attempt + 1 < maxAttempts) { await sleep(RETRY_DELAYS_MS[attempt]); continue; }
      return res;
    } catch (e) {
      clearTimeout(id);
      lastError = e;
      if (attempt + 1 < maxAttempts) await sleep(RETRY_DELAYS_MS[attempt]);
    }
  }
  throw lastError || new Error('Không kết nối được máy chủ');
};

const API = {
  // '+84 912 345 678' → '0912345678'
  formatPhoneNumber: (p) => {
    let s = String(p || '').replace(/\D/g, '');
    if (s.startsWith('84')) s = '0' + s.slice(2);
    return s;
  },

  // Trả { success, userInfo, accessToken } hoặc { success:false, errorCode, message }
  login: async (phoneNumber, password) => {
    const res = await fetchWithTimeout(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: phoneNumber, password }),
    });
    const json = await res.json().catch(() => ({}));
    if (res.ok) {
      const d = json.data || json;
      return { success: true, userInfo: d.userInfo, accessToken: d.accessToken };
    }
    return { success: false, errorCode: json.errorCode, message: json.message || `Lỗi ${res.status}` };
  },

  getUserProfile: async (accessToken) => {
    const res = await fetchWithTimeout(`${API_BASE_URL}/users/profile`, {
      headers: { 'x-access-token': accessToken },
    });
    const json = await res.json().catch(() => ({}));
    return res.ok ? { success: true, user: json.data || json } : { success: false };
  },
};

export default API;
